import React, { useState } from "react";
import BuyerKYB from "./BuyerKyb";
import KYBVerification from "./KYBVerification";

const KybModule = () => {
    const [activeTab, setActiveTab] = useState("Buyer");
    const tabs = ["Buyer", "Global Partner","Admin"];

const renderTabContent = () => {
    switch (activeTab) {
        case "Buyer":
            return <BuyerKYB mode="Buyer" />;  // No extra braces needed here
        case "Global Partner":
            return <BuyerKYB mode="GlobalPartner" />;
        case "Admin":
            return <KYBVerification />;
        default:
            return <BuyerKYB  mode="Buyer"/>;
    }
};

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default KybModule;